// PureDrop — galería de imágenes y selector de variantes de la página de producto

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pd-producto').forEach(initGaleriaPD);
  document.querySelectorAll('.pd-producto').forEach(initZoomPD);
  document.querySelectorAll('.pd-producto').forEach(initBarraFijaPD);
  document.querySelectorAll('.pd-form-producto').forEach(initVariantesPD);
});

function initGaleriaPD(seccion) {
  var principal = seccion.querySelector('[id^="pd-imagen-principal-"]');
  var miniaturas = seccion.querySelectorAll('[data-pd-galeria-thumb]');
  if (!principal || !miniaturas.length) return;

  miniaturas.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      if (!full) return;
      principal.src = full;
      miniaturas.forEach(function (t) { t.classList.remove('pd-activa'); });
      thumb.classList.add('pd-activa');
    });
  });
}

function initZoomPD(seccion) {
  var principal = seccion.querySelector('[id^="pd-imagen-principal-"]');
  if (!principal) return;
  var contenedor = principal.closest('.pd-galeria-principal');
  if (contenedor) contenedor.classList.add('pd-galeria-zoom');

  principal.addEventListener('click', function () {
    var overlay = document.createElement('div');
    overlay.className = 'pd-lightbox';
    var img = document.createElement('img');
    img.src = principal.src;
    img.alt = principal.alt;
    overlay.appendChild(img);

    function cerrar() {
      overlay.remove();
      document.removeEventListener('keydown', onKeydown);
    }
    function onKeydown(e) {
      if (e.key === 'Escape') cerrar();
    }
    overlay.addEventListener('click', cerrar);
    document.addEventListener('keydown', onKeydown);
    document.body.appendChild(overlay);
  });
}

function initBarraFijaPD(seccion) {
  var barra = seccion.querySelector('.pd-compra-fija');
  var botonPrincipal = seccion.querySelector('.pd-btn-comprar');
  if (!barra || !botonPrincipal) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        barra.classList.toggle('pd-visible-fija', !entry.isIntersecting);
      });
    },
    { threshold: 0 }
  );
  observer.observe(botonPrincipal);
}

function initVariantesPD(form) {
  var seccion = form.closest('.pd-producto');
  if (!seccion) return;

  var scriptVariantes = seccion.querySelector('script[id^="pd-variantes-"]');
  var inputId = form.querySelector('input[name="id"]');
  var boton = seccion.querySelector('.pd-btn-comprar');
  var botonTexto = boton ? boton.querySelector('.pd-boton-texto') : null;
  var precioActual = seccion.querySelector('.pd-precio-actual');
  var precioAnterior = seccion.querySelector('.pd-precio-anterior');
  var botonFijo = seccion.querySelector('.pd-compra-fija-boton');
  var precioFijo = seccion.querySelector('.pd-compra-fija-precio');
  var grupos = seccion.querySelectorAll('[data-pd-opcion-index]');

  if (!scriptVariantes || !inputId || !grupos.length) return;

  var variantes;
  try {
    variantes = JSON.parse(scriptVariantes.textContent);
  } catch (e) {
    return;
  }

  var textoDisponible = boton ? (boton.getAttribute('data-texto-disponible') || (botonTexto ? botonTexto.textContent : '')) : '';

  function seleccionActual() {
    var valores = [];
    grupos.forEach(function (grupo) {
      var activo = grupo.querySelector('.pd-seleccionada');
      valores.push(activo ? activo.getAttribute('data-pd-valor') : null);
    });
    return valores;
  }

  function encontrarVariante(valores) {
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === valores[i]; });
    });
  }

  function formatearDinero(centavos) {
    return (centavos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function actualizar() {
    var valores = seleccionActual();
    var variante = encontrarVariante(valores);
    if (!variante) return;

    inputId.value = variante.id;
    if (precioActual) precioActual.textContent = formatearDinero(variante.price);
    if (precioFijo) precioFijo.textContent = formatearDinero(variante.price);
    if (precioAnterior) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAnterior.textContent = formatearDinero(variante.compare_at_price);
        precioAnterior.style.display = '';
      } else {
        precioAnterior.style.display = 'none';
      }
    }

    if (boton) {
      if (variante.available) {
        boton.disabled = false;
        if (botonTexto && textoDisponible) botonTexto.textContent = textoDisponible;
      } else {
        boton.disabled = true;
        if (botonTexto) botonTexto.textContent = boton.getAttribute('data-texto-agotado') || botonTexto.textContent;
      }
    }
    if (botonFijo) botonFijo.disabled = !variante.available;
  }

  grupos.forEach(function (grupo) {
    grupo.querySelectorAll('.pd-opcion-valor').forEach(function (btnValor) {
      btnValor.addEventListener('click', function () {
        grupo.querySelectorAll('.pd-opcion-valor').forEach(function (b) { b.classList.remove('pd-seleccionada'); });
        btnValor.classList.add('pd-seleccionada');
        actualizar();
      });
    });
    if (!window.location.search.includes('variant=')) {
      var destacado = grupo.querySelector('.pd-opcion-badge');
      if (destacado) destacado.closest('.pd-opcion-valor').click();
    }
  });
}
